const validate = require("validate.js");

export default class ProfileTwitterEdit {
    constructor(args) {
        console.log('profile_twitter.js loaded');

        // Form validation
        let constraints = {
            'user[family_name]': {
                presence: {
                    message: "入力してください"
                }
            },
            'user[first_name]': {
                presence: {
                    message: "入力してください"
                }
            },
            'user[email]': {
                email: {
                  message: "正しいメールアドレスを入力ください"
                },
                presence: {
                  message: "入力してください"
                }
            },
            'user[agreement]': {
                presence: {
                    message: "利用規約を確認してください"
                },
                inclusion: {
                    within: [true, '1'],
                    message: "利用規約を確認してください"
                }
            }
        };

        // Hook up the form so we can prevent it from being posted
        let form = document.getElementById("profile_edit_form");
        form.onsubmit = function (ev) {
            ev.preventDefault();
            handleFormSubmit(form);
        }

        // Hook up the inputs to validate on the fly
        let inputs = document.querySelectorAll("input, textarea, select");
        inputs.forEach(function(element) {
            element.onchange = function(elem) {
                let errors = validate(form, constraints, {fullMessages: false}) || {};
                showErrorsForInput(this, errors[this.name]);
            }
        });

        function handleFormSubmit(form, input) {
            // validate the form against the constraints
            let errors = validate(form, constraints, {fullMessages: false});
            // then we update the form to reflect the results
            showErrors(form, errors || {});
            if (!errors) {
                showSuccess();
            }
        }

        // Updates the inputs with the validation errors
        function showErrors(form, errors) {
            // We loop through all the inputs and show the errors for that input
            form.querySelectorAll(".input_validate").forEach(function(input) {
                // Since the errors can be null if no errors were found we need to handle that
                showErrorsForInput(input, errors && errors[input.name]);
            });
        }

        // Shows the errors for a specific input
        function showErrorsForInput(input, errors) {
            // This is the root of the input
            let formGroup = closestParent(input.parentNode, "form-group")
            // Find where the error messages will be insert into
            let messages = formGroup.querySelector(".error-messages");
            // First we remove any old messages and resets the classes
            resetFormGroup(formGroup,messages);
            // If we have errors
            if (errors) {
                // we first mark the group has having errors
                formGroup.classList.add("has-error");
                // then we append all the errors
                errors.forEach(function(error) {
                    addError(messages, error);
                });
            } else {
                // otherwise we simply mark it as success
                formGroup.classList.add("has-success");
            }
        }

        // Recusively finds the closest parent that has the specified class
        function closestParent(child, className) {
            if (!child || child == document) {
                return null;
            }
            if (child.classList.contains(className)) {
                return child;
            } else {
                return closestParent(child.parentNode, className);
            }
        }

        function resetFormGroup(formGroup,messages) {
            // Remove the success and error classes
            formGroup.classList.remove("has-error");
            formGroup.classList.remove("has-success");
            messages.classList.remove("show");
            // and remove any old messages
            // _.each(formGroup.querySelectorAll(".help-block.error"), function(el) {
            //   el.parentNode.removeChild(el);
            // });
            formGroup.querySelectorAll(".help-block.error").forEach(function(element) {
                element.parentNode.removeChild(element);
            });

        }

        // Adds the specified error with the following markup
        // <p class="help-block error">[message]</p>
        function addError(messages, error) {
            let block = document.createElement("p");
            block.classList.add("help-block");
            block.classList.add("error");
            block.innerText = error;
            messages.appendChild(block);
            messages.classList.add("show");
        }

        function showSuccess() {
            form.submit()
        }

    }

    // methods
}



// WEBPACK FOOTER //
// ./pages/profile_twitter.js